"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "handleUncaughtErrors", {
    enumerable: true,
    get: function() {
        return handleUncaughtErrors;
    }
});
function handleUncaughtErrors(process) {
    process.on('uncaughtException', (err)=>{
        let handled = false;
        if (err.code) {
            switch(err.code){
                // ERR_STRING_TOO_LONG from pg-protocol cannot be caught, possibly because it has been
                // detached from process by setTimeout or setImmediate without promise
                case 'ERR_STRING_TOO_LONG':
                    handled = true;
                    break;
            }
        }
        if (!handled) {
            process.exit(1);
        }
    });
}
